APP.tabs = function () {
  $('.tabs .tab-item').click(function () {
    let section = $(this).closest('.section');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('.tab-content', section).removeClass('active');
    $('.tab-content#' + $(this).attr('id')).addClass('active');
  })
}

APP.tabFooter = function () {
  $('.tab .tab-link').click(function () {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('div').closest('.section').removeClass('active');
    $('.section__' + $(this).attr('id')).addClass('active');
  });
  $('a.update-info').click(function () {
    $('.section__account').addClass('update-user-info');
  });
  $('.go-home').click(function () {
    $('.section').removeClass('active');
    $('.section__home').addClass('active');
  })
}
